import createModel, { prop } from 'models/lib/create_model';

export default createModel({
  modelName: 'CustomerUnlink',

  properties: {
    customerId: prop(String),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/customer_unlink.js